import { Component, OnInit } from '@angular/core';
import { AppToastService } from '../../services/app-toast.service';

@Component({
  selector: 'app-toasts',
  templateUrl: './app-toasts.component.html',
  styleUrls: ['./app-toasts.component.scss']
})
export class AppToastsComponent implements OnInit {

  constructor(
    public toastService: AppToastService
  ) { }

  ngOnInit(): void {
  }

}
